import React from 'react';
import { Card } from 'react-bootstrap';
import ApexChart from 'react-apexcharts';
import { IoCall } from 'react-icons/io5';

const HourlyCallChart = ({ 
  title = "Hourly Calls",
  data = [
    { hour: "09 AM", count: 2 },
    { hour: "10 AM", count: 4 },
    { hour: "11 AM", count: 6 },
    { hour: "12 PM", count: 5 },
    { hour: "01 PM", count: 8 },
    { hour: "02 PM", count: 9 },
    { hour: "03 PM", count: 4 },
    { hour: "04 PM", count: 6 },
    { hour: "05 PM", count: 7 },
    { hour: "06 PM", count: 3 },
    { hour: "07 PM", count: 5 },
    { hour: "08 PM", count: 2 },
    { hour: "09 PM", count: 1 }
  ]
}) => {
  const chartOptions = {
    chart: {
      type: 'line',
      toolbar: { show: false },
      zoom: { enabled: false },
      animations: {
        enabled: true,
        easing: 'easeinout',
        speed: 600
      }
    },
    stroke: {
      curve: 'smooth',
      width: 3,
      colors: ['#3366cc'] // cleaner blue
    },
    markers: {
      size: 5,
      colors: ['#3366cc'],
      strokeColors: '#fff',
      strokeWidth: 2,
      hover: { size: 7 }
    },
    xaxis: {
      categories: data.map(item => item.hour),
      title: { text: "Time of Day", style: { fontSize: '13px', fontWeight: 600 } },
      labels: { style: { fontSize: '12px' } }
    },
    yaxis: {
      title: { text: "Call Count", style: { fontSize: '13px', fontWeight: 600 } },
      labels: { style: { fontSize: '12px' } },
      min: 0,
      forceNiceScale: true
    },
    dataLabels: {
      enabled: true,
      style: {
        fontSize: '12px',
        fontWeight: 'bold',
        colors: ['#333']
      },
      background: {
        enabled: true,
        foreColor: '#fff',
        padding: 4,
        borderRadius: 3,
        borderWidth: 0,
        opacity: 0.9,
        dropShadow: {
          enabled: true,
          top: 1,
          left: 1,
          blur: 2,
          color: '#000',
          opacity: 0.1
        }
      }
    },
    tooltip: {
      theme: 'light',
      y: {
        formatter: (val) => `${val} calls`
      }
    },
    grid: {
      borderColor: '#e0e0e0',
      strokeDashArray: 3
    }
  };

  const chartSeries = [
    {
      name: 'Calls',
      data: data.map(item => item.count)
    }
  ];

  return (
    <Card
      className="border-0 shadow-sm h-100 rounded-4"
      style={{
        background: 'linear-gradient(145deg, #f0f8ff, #ffffff)',
        backdropFilter: 'blur(2px)',
        transition: 'all 0.3s ease',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-2px)';
        e.currentTarget.style.boxShadow = '0 8px 24px rgba(0, 0, 0, 0.1)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = '0 2px 12px rgba(0, 0, 0, 0.06)';
      }}
    >
      <Card.Body>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h6 className="fw-bold text-dark mb-0">{title}</h6>
          <IoCall size={20} className="text-primary" />
        </div>

        <ApexChart
          options={chartOptions}
          series={chartSeries}
          type="line"
          height={280}
        />
      </Card.Body>
    </Card>
  );
};

export default HourlyCallChart;
